/**
 * @generated SignedSource<<07a98857bcd9076146edbd77ff50a309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemLiveArticleSummaryLiveContent$data = {
  readonly customTime: number | null | undefined;
  readonly entityUuid: string;
  readonly summary: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "itemLiveArticleSummaryLiveContent";
};
export type itemLiveArticleSummaryLiveContent$key = {
  readonly " $data"?: itemLiveArticleSummaryLiveContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleSummaryLiveContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemLiveArticleSummaryLiveContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveContent",
  "abstractKey": null
};

(node as any).hash = "fa67de3364233da166ce7e89b9ea09af";

export default node;
